module.exports = __webpack_public_path__ + "img/tempo-bg-general.9ec332be.png";